import { render, staticRenderFns } from "./userDate.vue?vue&type=template&id=383d034e&scoped=true&"
import script from "./userDate.vue?vue&type=script&lang=js&"
export * from "./userDate.vue?vue&type=script&lang=js&"
import style0 from "./userDate.vue?vue&type=style&index=0&id=383d034e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d034e",
  null
  
)

export default component.exports